import { render, staticRenderFns } from "./CombinationForm.vue?vue&type=template&id=48563520"
import script from "./CombinationForm.vue?vue&type=script&lang=js"
export * from "./CombinationForm.vue?vue&type=script&lang=js"
import style0 from "./CombinationForm.vue?vue&type=style&index=0&id=48563520&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports